__turbopack_context__.v({
  "helios-stat-card": "U0sP9q_helios-stat-card",
  "helios-stat-card__cta": "U0sP9q_helios-stat-card__cta",
  "helios-stat-card__desc": "U0sP9q_helios-stat-card__desc",
  "helios-stat-card__footnote": "U0sP9q_helios-stat-card__footnote",
  "helios-stat-card__stat": "U0sP9q_helios-stat-card__stat",
  "helios-stat-card__stat--lg": "U0sP9q_helios-stat-card__stat--lg",
  "helios-stat-card__stat--md": "U0sP9q_helios-stat-card__stat--md",
  "helios-stat-grid": "U0sP9q_helios-stat-grid",
  "helios-stat-grid--cols-2": "U0sP9q_helios-stat-grid--cols-2",
  "helios-stat-grid--cols-3": "U0sP9q_helios-stat-grid--cols-3",
  "helios-stat-grid--cols-4": "U0sP9q_helios-stat-grid--cols-4",
  "helios-stat-grid--metric": "U0sP9q_helios-stat-grid--metric",
  "helios-stat-metric": "U0sP9q_helios-stat-metric",
  "helios-stat-metric__desc": "U0sP9q_helios-stat-metric__desc",
  "helios-stat-metric__desc--body": "U0sP9q_helios-stat-metric__desc--body",
  "helios-stat-metric__desc--lg": "U0sP9q_helios-stat-metric__desc--lg",
  "helios-stat-metric__footnote": "U0sP9q_helios-stat-metric__footnote",
  "helios-stat-metric__label": "U0sP9q_helios-stat-metric__label",
  "helios-stat-metric__stat": "U0sP9q_helios-stat-metric__stat",
  "helios-stat-metric__stat--compact": "U0sP9q_helios-stat-metric__stat--compact",
});
